import { styled } from '@mui/material';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});

export const Select = styled('select')({
  background: 'white',
  border: '1px solid #d7d7d7',
  borderRadius: '3px',
  marginLeft: '16px',
  padding: '14px 16px',
  width: '375px',
});

export const IndividualOption = styled('div')({
  alignItems: 'center',
  display: 'flex',
  paddingBottom: '24px',
});

export const Option = styled('option')({
  paddingBottom: '8px',
});
